import React, { useState, useMemo, useEffect } from "react";
import { DataTable } from "../../../DataTable";
import { Tooltip } from 'react-tooltip';

import 'react-tooltip/dist/react-tooltip.css';
import "../../../../css/components/OrderInfo/OrderSheet/OrderSheet.css"

import { ImageModal } from "../../../../components";
import { calcCO2Emission, formatTaiwanDate, Message, OrderId } from "../../../../utils";
import { Deliver_OrderDataColums } from "../../../../constants";

import { getOptimizeRoute } from "../../../../service/api/OptimizeRoute/apiOPR";

const OrderSheet = ({ data, selectedRows, setSelectedRows, deliveryDate, setDeliveryDate, routeData, setRouteData, addressOptions }) => {
    useEffect(() => {
        if (data) {
            setOrdersData(data.filter(item => item.status === 1));
        }
    }, [data]);

    useEffect(() => {
        const selectedSet = new Set(selectedRows);
        const filtered = data
            .filter(item => selectedSet.has(item.id))
        // .map(item => (item.addressCity + item.addressDetailed + item.addressDistrict));

        setSelectedData(filtered);
    }, [selectedRows]);

    const urlParams = new URLSearchParams(window.location.search);
    const [imageModal, setImageModal] = useState({ open: false, src: "" });
    const [statusFilter, setStatusFilter] = useState(urlParams.get("status") ?? 'all'); // 寄送狀態
    const [deliverFilter, setDeliverFilter] = useState(urlParams.get("deliver") ?? 'notDeliver'); // 有無司機
    const [areaFilter, setAreaFilter] = useState(""); // 地區
    const [cityFilter, setCityFilter] = useState(""); // 縣市
    const [ordersData, setOrdersData] = useState([]);
    const [showColumnSelector, setShowColumnSelector] = useState(false); // 控制折疊展開
    const [filterText, setFilterText] = useState("");
    const [deliveryDateSort, setDeliveryDateSort] = useState(false)
    const [bestRouteClick, setBestRouteClick] = useState(false);
    const [dateRange, setDateRange] = useState({ start: urlParams.get("start") ?? "", end: urlParams.get("end") ?? "" });
    const [selectedData, setSelectedData] = useState([]);
    const [loading, setLoading] = useState(false);

    const closeImage = () => setImageModal({ open: false, src: "" });

    const filteredItems = useMemo(() => {
        return ordersData.filter(item => {
            // 文字搜尋
            let matchText = true;
            if (!deliveryDateSort) {
                matchText =
                    OrderId(item.id).includes(filterText) ||
                    item.name?.toLowerCase().includes(filterText.toLowerCase()) ||
                    item.phone?.includes(filterText) ||
                    item.email?.toLowerCase().includes(filterText.toLowerCase()) ||
                    item.deliveryDate?.includes(filterText) ||
                    item.addressCity?.includes(filterText) ||
                    item.addressDistrict?.includes(filterText) ||
                    item.addressDetailed?.includes(filterText) ||
                    item.deliverName?.includes(filterText);
            }

            const matchCity =
                cityFilter === 'all' ||
                item.addressCity?.includes(cityFilter);

            const matchArea =
                areaFilter === 'all' ||
                item.addressDistrict?.includes(areaFilter);

            // 已送達狀態篩選
            const matchStatus =
                statusFilter === 'all' ||
                (statusFilter === 'shipped' && item.isShipped) ||
                (statusFilter === 'notShipped' && !item.isShipped);

            const matchDeliver =
                deliverFilter === 'all' ||
                (deliverFilter === 'hasDeliver' && (item.deliverName !== "" && item.deliverName !== null)) ||
                (deliverFilter === 'notDeliver' && (item.deliverName === "" || item.deliverName === null));

            // 日期篩選
            let matchDate = true;
            if (deliveryDateSort) {
                if (deliveryDate) {
                    const itemDate = new Date(item.deliveryDate);
                    const startDate = deliveryDate ? new Date(deliveryDate) : null;
                    const endDate = deliveryDate ? new Date(deliveryDate) : null;

                    if (startDate && itemDate < startDate) matchDate = false;
                    if (endDate && itemDate > endDate) matchDate = false;
                }
            } else {
                if (dateRange.start || dateRange.end) {
                    const itemDate = new Date(item.deliveryDate);
                    const startDate = dateRange.start ? new Date(dateRange.start) : null;
                    const endDate = dateRange.end ? new Date(dateRange.end) : null;

                    if (startDate && itemDate < startDate) matchDate = false;
                    if (endDate && itemDate > endDate) matchDate = false;
                }
            }

            return matchText && matchStatus && matchDate && matchDeliver && matchCity && matchArea;
        });
    }, [ordersData, filterText, statusFilter, dateRange, deliverFilter, deliveryDateSort, cityFilter, areaFilter]);

    const allColumns = [
        {
            name: (
                <input
                    type="checkbox"
                    disabled={bestRouteClick}
                    onChange={(e) => {
                        if (e.target.checked) {
                            // 全選目前篩選後的項目
                            setSelectedRows(filteredItems.map((item) => item.id));
                        } else {
                            // 全部取消
                            setSelectedRows([]);
                        }
                    }}
                />
            ),
            cell: (row) => (
                <label className="small-btn">
                    <input
                        type="checkbox"
                        disabled={bestRouteClick}
                        checked={selectedRows.includes(row.id)}
                        onChange={(e) => {
                            if (!selectedRows.includes(row.id)) {
                                setSelectedRows((prev) => [...prev, row.id]);
                            } else {
                                setSelectedRows((prev) => prev.filter((id) => id !== row.id));
                            }
                        }}
                    />
                </label>
            ),
            key: "check",
            width: "60px",

        },
        ...Deliver_OrderDataColums
    ];

    const [selectedColumns, setSelectedColumns] = useState(
        allColumns
            .map(col => col.key)
        // .filter(key => /*key !== "addressDistrict" &&*/ key !== "check") // 預設不勾選 區、check
    );
    const toggleColumn = key => setSelectedColumns(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);
    const columnsToShow = allColumns.filter(col => selectedColumns.includes(col.key));

    const handleBestRouterClick = async () => {
        {
            setLoading(true);
            if (!bestRouteClick) {
                if (selectedData.length <= 0) {
                    Message('請規劃一條以上的地址路徑', 'warning');
                    setLoading(false);
                    return;
                }
                const result = await getOptimizeRoute(selectedData);
                if (result?.status === 200) {
                    console.log(result.data);
                    if (result.data.resortData.length <= 0 || result.data.mapsUrl === '') {
                        Message(result.status + ('未產生網址與排序資料'), 'error')
                        setLoading(false);
                        return;
                    };
                    const { resortData, mapsUrl, totalDrivingKm, totalDrivingTime, totalLongDrivingKm } = result.data;
                    const weight = selectedData.reduce((sum, data) => sum + data.weight, 0);
                    setOrdersData(resortData);
                    setBestRouteClick(true);
                    setRouteData(
                        {
                            mapUrl: mapsUrl,
                            orderId: resortData.map(data => data.id),
                            drivingKm: totalDrivingKm,
                            longDrivingKm: totalLongDrivingKm,
                            drivingTime: totalDrivingTime,
                            weight,
                            carbonReduction: calcCO2Emission(weight, totalDrivingKm),
                        }
                    );
                }
            } else {
                setBestRouteClick(false);
                setOrdersData(data.filter(item => item.status === 1));
                setSelectedRows([]);
                setRouteData(
                    {
                        mapUrl: '',
                        orderId: null,
                        drivingKm: 0,
                        drivingTime: 0,
                        weight: 0,
                        carbonReduction: 0,
                    }
                );
            }
            setLoading(false);
        }
    }

    const handleReSet = () => {
        setSelectedRows([]);
        setDateRange({})
        setRouteData(
            {
                mapUrl: '',
                orderId: null,
                drivingKm: 0,
                drivingTime: 0,
                weight: 0,
                carbonReduction: 0,
            }
        );
    }

    return (
        <>
            {/* <div className="orderSheet container-fluid"> */}
            <h1 className="h4 mb-4 mt-4 text-gray-800 text-primary">選擇訂單</h1>

            <div className="card shadow mb-4">

                {/* 額外篩選區塊 */}
                <div className="card-body border-top sheet-toolbar">
                    <div className="sheet_filter_container">
                        {/* 狀態篩選 */}
                        {
                            !deliveryDateSort &&
                            !bestRouteClick &&
                            <>
                                <div className="sheet_filter">

                                    {/* 已送達篩選 */}
                                    <div className="d-flex gap-1">
                                        <button
                                            className={`btn btn-action--sm ${statusFilter === 'all' ? 'btn-action--primary' : 'btn-action--neutral btn-action--soft'}`}
                                            onClick={() => setStatusFilter('all')}
                                        >全部</button>
                                        <button
                                            className={`btn btn-action--sm ${statusFilter === 'shipped' ? 'btn-action--confirm' : 'btn-action--neutral btn-action--soft'}`}
                                            onClick={() => setStatusFilter('shipped')}
                                        >已送達</button>
                                        <button
                                            className={`btn btn-action--sm ${statusFilter === 'notShipped' ? 'btn-action--warning' : 'btn-action--neutral btn-action--soft'}`}
                                            onClick={() => setStatusFilter('notShipped')}
                                        >未送達</button>
                                    </div>

                                    {/* 有無司機篩選 */}
                                    <div className="d-flex gap-1">
                                        <button
                                            className={`btn btn-action--sm ${deliverFilter === 'all' ? 'btn-action--primary' : 'btn-action--neutral btn-action--soft'}`}
                                            onClick={() => setDeliverFilter('all')}
                                        >全部</button>
                                        <button
                                            className={`btn btn-action--sm ${deliverFilter === 'hasDeliver' ? 'btn-action--confirm' : 'btn-action--neutral btn-action--soft'}`}
                                            onClick={() => setDeliverFilter('hasDeliver')}
                                        >已指定</button>
                                        <button
                                            className={`btn btn-action--sm ${deliverFilter === 'notDeliver' ? 'btn-action--warning' : 'btn-action--neutral btn-action--soft'}`}
                                            onClick={() => setDeliverFilter('notDeliver')}
                                        >未指定</button>
                                    </div>

                                    {/* 日期篩選 */}
                                    <div className="date-range-inline">
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={dateRange.start}
                                            disabled={deliveryDateSort}
                                            onChange={(e) => setDateRange(prev => ({ ...prev, start: e.target.value }))}
                                        />
                                        <span>～</span>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={dateRange.end}
                                            disabled={deliveryDateSort}
                                            onChange={(e) => setDateRange(prev => ({ ...prev, end: e.target.value }))}
                                        />
                                    </div>

                                    {/* 欄位選擇 */}
                                    <div className="sheet-actions">
                                        <button
                                            className="btn btn-action--neutral btn-action--soft btn-action--sm"
                                            onClick={() => setShowColumnSelector(prev => !prev)}
                                        >
                                            {showColumnSelector ? "收起欄位" : "選擇欄位"}
                                        </button>
                                    </div>
                                </div>

                                <input
                                    type="text"
                                    placeholder="搜尋"
                                    className="form-control ms-2 me-2 mt-3 mb-3"
                                    value={filterText}
                                    onChange={e => setFilterText(e.target.value)}
                                    style={{ maxWidth: "200px" }}
                                />
                            </>
                        }

                    </div>
                    {
                        deliverFilter === 'notDeliver' &&
                        <div className="sheet_filter">
                            <div>請選擇指派日期: </div>
                            <input
                                disabled={bestRouteClick}
                                type="date"
                                className="img-thumbnail ms-2 me-2"
                                value={deliveryDate}
                                onChange={(e) => {
                                    setDeliveryDate(e.target.value);
                                    handleReSet();
                                }}
                            />
                            <div className="form-check form-switch">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="deliveryDate"
                                    name="deliveryDate"
                                    disabled={bestRouteClick}
                                    value={deliveryDateSort}
                                    onChange={e => {
                                        setDeliveryDateSort(prev => !prev);
                                        handleReSet();
                                    }}
                                />
                                <label className="form-check-label" htmlFor="sendEmail">
                                    依此日期排序
                                </label>
                            </div>
                            <div className="">
                                <select
                                    className="form-select"
                                    value={areaFilter}
                                    disabled={bestRouteClick}
                                    onChange={e => {
                                        setAreaFilter(prev => e.target.value);
                                        handleReSet();
                                    }}
                                >
                                    <option value={"all"}>
                                        空白
                                    </option>
                                    {
                                        addressOptions.map(option =>
                                            <option key={option.id} data-id={option.id} value={option.name}>
                                                {option.district}
                                            </option>)
                                    }

                                </select>
                            </div>
                            <div className="">
                                <select
                                    className="form-select"
                                    value={cityFilter}
                                    disabled={bestRouteClick}
                                    onChange={e => {
                                        setCityFilter(prev => e.target.value);
                                        handleReSet();
                                    }}
                                >
                                    <option value={"all"}>
                                        空白
                                    </option>
                                    {
                                        [...new Map(addressOptions.map(item => [item.city, item])).values()]
                                            .map(option => (
                                                <option key={option.id} data-id={option.id} value={option.name}>
                                                    {option.city}
                                                </option>
                                            ))
                                    }

                                </select>
                            </div>
                            <button
                                disabled={loading}
                                className="btn btn-action--confirm btn-action--soft"
                                onClick={handleBestRouterClick}
                            >
                                <i className="fas fa-route me-2"></i>{!bestRouteClick ? loading ? '規劃中...' : '產生最佳路線並排序' : '重新設定路線'}
                            </button>
                            {
                                routeData.mapUrl &&
                                <a className="btn btn-action--confirm btn-action--soft" onClick={() => window.open(routeData.mapUrl, "_blank")}>查看路線</a>
                            }
                        </div>
                    }
                    <div className="d-flex flex-wrap gap-2 mt-3">
                        {showColumnSelector &&
                            allColumns.map(col => {
                                const isSelected = selectedColumns.includes(col.key);
                                return (
                                    <button
                                        key={col.key}
                                        type="button"
                                        className={`btn btn-action--sm ${isSelected ? 'btn-action--primary' : 'btn-action--neutral btn-action--soft'}`}
                                        onClick={() => toggleColumn(col.key)}
                                    >
                                        {col.key !== 'check' ? (col.name) : '選擇'} {isSelected && <span className="badge bg-light text-dark ms-1">✓</span>}
                                    </button>
                                )
                            })
                        }
                    </div>
                </div>

                <div className="orderSheetData card-body pt-0">
                    <DataTable
                        columns={columnsToShow}
                        data={filteredItems}
                        pagination
                        highlightOnHover
                        striped
                        responsive
                        noDataComponent="無此訂單資訊"
                        paginationComponentOptions={{
                            rowsPerPageText: '每頁筆數',
                            rangeSeparatorText: '總共',
                            // selectAllRowsItem: true,
                            // selectAllRowsItemText: '全部'
                        }}
                    />
                </div>
            </div>
            {/* </div > */}
            {
                imageModal.open && (
                    <ImageModal
                        image={imageModal}
                        closeImage={closeImage} />
                )
            }
            < Tooltip id="email-tooltip" />
        </>
    );
};

export { OrderSheet };
